import { AxiosPromise } from 'axios';
import { URLS } from '@/services/Constants';
import { cloudAxios as axios } from './Authentication';

export default {
    // GET

    /**
     * Return invoices
     *
     * @returns {AxiosPromise<any>}
     */
    getInvoices(): AxiosPromise<any> {
        return axios().request({
            url: URLS().cloudUrlInvoices,
            method: 'get'
        });
    }
};
